var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnseald(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 66,
    viewBox: "0 0 346 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.896 65.184C9.408 65.184 0 54.24 0 38.496V0H13.824V38.016C13.824 46.944 19.008 53.088 28.896 53.088C38.784 53.088 43.872 46.944 43.872 38.016V0H57.792V38.4C57.792 54.336 48.384 65.184 28.896 65.184Z",
    fill: "url(#paint0_linear_916_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.606 64.032H101.414V36C101.414 29.568 98.0543 27.36 92.8703 27.36C88.0703 27.36 84.3262 30.048 82.3102 32.832V64.032H70.1182V17.664H82.3102V23.712C85.2862 20.16 90.9503 16.512 98.5343 16.512C108.71 16.512 113.606 22.272 113.606 31.296V64.032Z",
    fill: "url(#paint1_linear_916_6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.416 65.184C134.352 65.184 126.576 62.496 121.68 57.984L126.96 49.44C130.32 52.608 137.232 55.776 142.992 55.776C148.272 55.776 150.768 53.664 150.768 50.784C150.768 43.104 123.216 49.344 123.216 31.104C123.216 23.328 130.032 16.512 142.224 16.512C150.096 16.512 156.336 19.2 160.944 22.848L156.048 31.2C153.264 28.224 147.984 25.824 142.32 25.824C137.904 25.824 135.024 27.84 135.024 30.432C135.024 37.344 162.48 31.584 162.48 50.304C162.48 58.752 155.28 65.184 142.416 65.184Z",
    fill: "url(#paint2_linear_916_6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.254 65.184C179.142 65.184 168.486 55.68 168.486 40.8C168.486 27.36 178.374 16.512 192.486 16.512C206.31 16.512 215.718 26.88 215.718 42.048V44.736H181.254C182.022 50.592 186.726 55.488 194.598 55.488C198.534 55.488 204.006 53.76 206.982 50.88L212.358 58.752C207.75 62.976 200.454 65.184 193.254 65.184ZM203.91 36.48C203.622 32.064 200.55 26.208 192.486 26.208C184.902 26.208 181.638 31.872 181.062 36.48H203.91Z",
    fill: "url(#paint3_linear_916_6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.556 64.032H252.365V59.232C249.197 62.976 243.725 65.184 237.676 65.184C230.285 65.184 221.549 60.192 221.549 49.824C221.549 38.976 230.285 34.848 237.676 34.848C243.82 34.848 249.292 36.864 252.365 40.512V34.272C252.365 29.568 248.333 26.496 242.189 26.496C237.197 26.496 232.589 28.32 228.652 31.968L224.044 23.808C229.708 18.816 237.005 16.512 244.301 16.512C254.861 16.512 264.556 20.736 264.556 34.08V64.032ZM242.572 56.928C246.508 56.928 250.348 55.584 252.365 52.896V47.136C250.348 44.448 246.508 43.104 242.572 43.104C237.772 43.104 233.837 45.6 233.837 50.112C233.837 54.432 237.772 56.928 242.572 56.928Z",
    fill: "url(#paint4_linear_916_6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.841 64.032H276.65V0H288.841V64.032Z",
    fill: "url(#paint5_linear_916_6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M345.091 64.032H332.803V58.08C329.155 62.688 324.067 65.184 318.499 65.184C306.787 65.184 297.955 56.352 297.955 40.896C297.955 25.728 306.691 16.512 318.499 16.512C323.971 16.512 329.155 18.912 332.803 23.616V0H345.091V64.032ZM322.243 54.336C326.371 54.336 330.787 52.128 332.803 49.056V32.64C330.787 29.568 326.371 27.36 322.243 27.36C315.331 27.36 310.531 32.832 310.531 40.896C310.531 48.864 315.331 54.336 322.243 54.336Z",
    fill: "url(#paint6_linear_916_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_916_6",
    x1: 0.00000153309,
    y1: 33,
    x2: 345,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03173E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175ADB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnseald);
export default __webpack_public_path__ + "static/media/unseald.d061b3329db791f928e7830e6c91ca89.svg";
export { ForwardRef as ReactComponent };